













































import { Vue, Component } from "@/shared/vuepack";
import { BalanceTransferMethod } from "@/shared/types";
import Button from "@/shared/components/ui/Button.vue";
import { useBalanceTransferStore } from "@/employee/store/balanceTransfer";

@Component({
  components: {
    Button
  }
})
export default class TransferFunds extends Vue {
  balanceTransferStore = useBalanceTransferStore();

  BalanceTransferMethod = BalanceTransferMethod;

  selectedMethod = BalanceTransferMethod.None;

  get nextDisabled () {
    return this.selectedMethod === BalanceTransferMethod.None;
  }

  updateSelection (transferMethod: BalanceTransferMethod) {
    this.selectedMethod = transferMethod;
  }

  isSelected (transferMethod: BalanceTransferMethod) {
    return this.selectedMethod === transferMethod;
  }

  onNext () {
    this.balanceTransferStore.transferMethod = this.selectedMethod;
    window.alert(`Selection ${this.balanceTransferStore.transferMethod} saved. Move to next step.`);
  }
}
